export const AccessibilityIcon = ({
  title = "Accessibility",
  width = 27,
  height = 27,
  className,
}: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      fill="none"
      viewBox="0 0 27 27"
      className={className}>
      <title>{title}</title>
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M1.554 18.45c0-3.898 2.61-7.139 6.143-8.185v1.997c-2.573.964-4.37 3.393-4.37 6.187 0 3.624 3.009 6.638 6.837 6.638 3.387 0 6.127-2.356 6.714-5.41l1.295 1.923a8.63 8.63 0 0 1-8.01 5.4c-4.701 0-8.609-3.792-8.609-8.55m18.18 3.993c-1.128-1.676-3.38-5.034-3.38-5.034l-6.543.029a1.413 1.413 0 0 1-1.428-1.407V6.965c0-.77.28-1.712 1.8-1.715.233 0 .62.074.828.216l6.019 4.087c.557.378.698 1.122.314 1.67a1.23 1.23 0 0 1-1.695.309l-3.857-2.626v5.643l5.41-.018c.45-.002.835.22 1.113.524 1.096 1.2 3.09 4.393 4.096 5.87.202.295.278.607.313.937.095.84-.695 1.528-1.552 1.528-.65 0-1.1-.445-1.438-.947m-6.523-8.972a.357.357 0 0 1-.362-.355v-.132c0-.198.16-.356.362-.356h6.818l4.81-4.734a.36.36 0 0 1 .257-.104c.092 0 .186.034.257.104l.094.093a.353.353 0 0 1 0 .506l-4.951 4.876a.4.4 0 0 1-.276.102zm-4.22-10.93C8.992 1.138 10.148 0 11.574 0s2.58 1.138 2.58 2.54c0 1.404-1.155 2.541-2.58 2.541s-2.581-1.137-2.581-2.54"
        clipRule="evenodd"></path>
    </svg>
  );
};
